import { Button, Text, VStack } from '@chakra-ui/react';
import { Trans } from '@lingui/react/macro';
import { t } from '@lingui/core/macro';
import { ChevronLeft } from 'lucide-react';
import {
  FormContentContainer,
  FormFooterContainer,
} from '@duke-hq/ui/components/Modals/FormModalLayouts';
import { EmployerCoursesToggleList } from '../components/EmployerCoursesToggleList';
import { testIds } from '../testIds';

export function EmployerCourses({
  courseIds,
  setCourseIds,
  goToPrevStep,
  onSave,
  isSaving,
}: {
  courseIds: Set<string>;
  setCourseIds: (ids: Set<string>) => void;
  goToPrevStep: () => void;
  onSave: () => void;
  isSaving: boolean;
}): React.ReactElement {
  return (
    <>
      <FormContentContainer>
        <VStack align="stretch" spacing={3} w="full" pb={4}>
          <Text fontWeight="semibold">
            <Trans>Which courses are suitable for this placement at this business?</Trans>
          </Text>
          <Text fontSize="sm" color="fg.subtle">
            <Trans>Select the relevant courses below.</Trans>
          </Text>

          <EmployerCoursesToggleList selectedIds={courseIds} onChange={setCourseIds} />
        </VStack>
      </FormContentContainer>

      <FormFooterContainer>
        <Button
          variant="primary"
          onClick={onSave}
          isLoading={isSaving}
          loadingText={t`Saving Employer`}
          data-testid={testIds.saveEmployerButton}
        >
          <Trans>Save Employer</Trans>
        </Button>
        <Button
          variant="secondary"
          leftIcon={<ChevronLeft />}
          onClick={goToPrevStep}
          isDisabled={isSaving}
        >
          <Trans>Back</Trans>
        </Button>
      </FormFooterContainer>
    </>
  );
}
